import { useEffect } from 'react';
import { useWorkbench } from './WorkbenchContext';
import { usePageData } from '../../pm/contexts/PageDataContext';

// This component bridges the Workbench context to PageData context
// so AiAssistant can access workbench state
function WorkbenchAwareAssistant() {
  const workbenchContext = useWorkbench();
  const { setPageData } = usePageData();

  useEffect(() => {
    // Update pageData with workbench context
    setPageData({ workbenchContext });
  }, [
    workbenchContext.containerLength,
    workbenchContext.containerWidth,
    workbenchContext.selectedComponents,
    workbenchContext.optimizedLayout,
    workbenchContext.activeTab,
    workbenchContext.currentDocument,
    workbenchContext.uploadedRequirementsFiles,
    workbenchContext.requirementsOutputs,
    workbenchContext.selectedRequirementOutput,
    workbenchContext.currentRequirementsDocument,
    workbenchContext.selectedRequirementFileIds,
    // Case context
    workbenchContext.cases,
    workbenchContext.activeCaseId,
    workbenchContext.activeCase,
    setPageData
  ]);

  return null; // This component doesn't render anything
}

export default WorkbenchAwareAssistant;
